import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withKeys as _withKeys, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "mdp-Close" }, null, -1)

import { BFormInput } from "bootstrap-vue";
import { ref, watch } from "vue";
import Icon from "./Icon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CommonFilter',
  props: {
    value: {},
    noMaxWidth: { type: Boolean },
    prependIcon: {},
    placeholder: {},
    triggerTime: { default: 500 },
    triggerByTime: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }) {

const props = __props;

const search = ref<BFormInput | null>(null);



const internValue = ref(props.value);



watch(
  () => props.value,
  (nv) => {
    internValue.value = nv;
  }
);

watch(internValue, (nv) => {
  if (props.triggerByTime) {
    triggerAfterTime(props.triggerTime);
  } else {
    emits("input", nv);
  }
});

const clearSearch = () => {
  emits("input", null);
};

const triggerAfterTime = async (timeInMS: number) => {
  setTimeout(() => {
    emits("input", internValue.value);
  }, timeInMS);
};

return (_ctx: any,_cache: any) => {
  const _component_b_input_group_text = _resolveComponent("b-input-group-text")!
  const _component_b_input = _resolveComponent("b-input")!
  const _component_b_btn = _resolveComponent("b-btn")!
  const _component_b_input_group_append = _resolveComponent("b-input-group-append")!
  const _component_b_input_group = _resolveComponent("b-input-group")!

  return (_openBlock(), _createBlock(_component_b_input_group, {
    class: _normalizeClass(["filter-input-group", { 'no-max-width': _ctx.noMaxWidth }])
  }, _createSlots({
    default: _withCtx(() => [
      _createVNode(_component_b_input, {
        class: "filter-input",
        placeholder: _ctx.placeholder,
        modelValue: internValue.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((internValue).value = $event)),
        type: "text",
        ref_key: "search",
        ref: search,
        onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (internValue.value = search.value?.value), ["enter"])),
        lazy: !_ctx.triggerByTime,
        "data-cy": "filter-txt"
      }, null, 8, ["placeholder", "modelValue", "lazy"]),
      (internValue.value)
        ? (_openBlock(), _createBlock(_component_b_input_group_append, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_b_btn, {
                onClick: clearSearch,
                "data-cy": "clear-filter-button"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 2
  }, [
    (_ctx.prependIcon)
      ? {
          name: "prepend",
          fn: _withCtx(() => [
            _createVNode(_component_b_input_group_text, null, {
              default: _withCtx(() => [
                _createVNode(Icon, { icon: _ctx.prependIcon }, null, 8, ["icon"])
              ]),
              _: 1
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["class"]))
}
}

})